import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const contentRowNames = this.props.rowNames

        return (
            <div>
                <h3><center><u>Factory Employee Attendance Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>OperationEntity: </b> {searchData.factory}</div>
                    <div className="col"><b>CollectionCategory: </b> {searchData.route}</div>
                    <div className="col"><b>ToDate: </b> {searchData.toDate}</div>
                    <div className="col"><b>FromDate: </b> {searchData.fromDate}</div>
                </div>
         

                <div> 
                        <table className="table table-bordered pb-3">
                            <thead>
                                <tr>
                                    <th>Factory</th>
                                    <th>Route</th>
                                    <th>Employee Number</th>
                                    <th>Employee Name</th>
                                    <th>Designation</th>
                                    <th>Date</th>
                                    <th>InTime</th>
                                    <th>OutTime</th>
                                </tr>
                            </thead>
                            <tbody>
                                    <TableContent
                                        data={data}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                    
                            </tbody>
                     </table>
                </div>           
            </div>
        );
    }
}


